import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";
import { AlertTriangle, Calendar, CheckCircle, Clock } from "lucide-react";
import React from "react";
import { useComplaintsSummary, useConsumerComplaintSummary } from "../../hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";

export const Summary: React.FC = () => {
  const remoteUtilityId = useRemoteUtilityId();
  // const { data: summaryData } = useComplaintsSummary(Number(remoteUtilityId));
  const { data: summaryData } = useConsumerComplaintSummary(
    remoteUtilityId,
    "summary",
    "Complaint",
  );
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <QuickStatsCard
        title="Pending Complaints"
        tooltip="Complaints that are logged but not yet resolved."
        count={summaryData?.totalPending}
        trendSummary="No trend data available"
        trend={summaryData?.percentChange?.pending}
        icon={<AlertTriangle className="h-8 w-8 text-amber-500" />}
      />
      <QuickStatsCard
        title="Today's Completed Complaints"
        tooltip="Today's Complaints successfully resolved and closed."
        count={summaryData?.totalCompletedToday}
        trendSummary="No trend data available"
        trend={summaryData?.percentChange?.completedToday}
        icon={<Calendar className="h-8 w-8 text-blue-500" />}
      />
      <QuickStatsCard
        title="Rejected Complaints"
        tooltip="Complaints that were invalid or not accepted."
        count={summaryData?.totalRejectedToday}
        trendSummary="No trend data available"
        trend={summaryData?.percentChange?.rejectedToday}
        icon={<Clock className="h-8 w-8 text-red-500" />}
      />
      <QuickStatsCard
        title="Breached SLA Complaints"
        tooltip="Complaints not resolved within the defined SLA timeframe."
        count={summaryData?.currentMonthSlaBreached}
        trendSummary=" " // white space given because no text to show not even the default text.
        trendDirection="up"
        icon={<CheckCircle className="h-8 w-8 text-green-500" />}
      />
    </div>
  );
};
